import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import { noop } from '../propTypes';
import { PICTURE_VARIANTS } from '../constants';
import Picture from '../Picture';
import iconTick from './../../icons/icons-tick.svg';

function ThemeInputSelector({
    title,
    themes,
    selectedTheme,
    onSelect,
    cardImage,
    cardTitle,
}) {
    useEffect(() => {
        if (!selectedTheme) onSelect(Object.keys(themes)[0]);
    }, []);
    const cardStyleTop = selectedTheme
        ? {
              background: `linear-gradient(to right, ${selectedTheme.shade1}, ${selectedTheme.shade2})`,
          }
        : {};
    return (
        <div className="radio-with-options">
            <h3 className="titleStyle2">{title}</h3>
            <div className="d-flex">
                {Object.values(themes).map((theme) => (
                    <div
                        key={theme.value}
                        className="theme-color-option"
                        style={{
                            background: `linear-gradient(to bottom, ${
                                theme.shade1
                            }${theme == selectedTheme ? 'CC' : 'FF'}, ${
                                theme.shade2
                            }${theme == selectedTheme ? 'CC' : 'FF'})`,
                        }}
                        onClick={() => onSelect(theme.value)}
                    >
                        {theme == selectedTheme ? (
                            <img
                                style={{
                                    margin: '12px',
                                }}
                                src={iconTick}
                            />
                        ) : (
                            ''
                        )}
                    </div>
                ))}
            </div>
            <div className="row py-3 px-2">
                <div className="col col-9 col-xl-6 challenge-card p-0">
                    <div
                        className="h-50 row p-4 align-content-center position-relative"
                        style={cardStyleTop}
                    >
                        <div className="col col-3 m-auto position-absolute">
                            <Picture
                                source={cardImage}
                                variant={PICTURE_VARIANTS.VARIANT_SMALL}
                            />
                        </div>
                        <div className="col offset-3 offset-md-2 offset-3 pl-4 col-auto  my-auto card-title">
                            {cardTitle}
                        </div>
                    </div>
                    <div className="h-50 p-4 row">
                        <div className="col col-11 card-content-template">
                            {' '}
                        </div>
                        <div className="col col-7 mt-2 card-content-template">
                            {' '}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

ThemeInputSelector.propTypes = {
    title: PropTypes.string,
    themes: PropTypes.object,
    selectedTheme: PropTypes.object,
    onSelect: PropTypes.func,
    cardTitle: PropTypes.string,
    cardImage: PropTypes.string,
    // selected: PropTypes.string,
};

ThemeInputSelector.defaultProps = {
    title: 'Challenges',
    themes: null,
    selectedTheme: null,
    onSelect: noop,
    cardTitle: '',
    cardImage: '',
    // options: [],
    // selected: 'challenge',
};

export default ThemeInputSelector;
